export const TEAM_QUESTION_COUNT = 12;
export const NOMINAL_CONTEST_DURATION_LABEL = '۱۸۰';

export const timeRules = [
  { label: 'سخت', value: '۱۵ دقیقه' },
] as const;

export const powerUpRules = [
  { title: 'راهنما', detail: 'بعد از ۳ جواب کامل پشت‌سرهم آزاد می‌شود و همان سؤال را با ضریب ۹۰٪ حساب می‌کند.' },
  { title: '۳۰ ثانیه اضافه', detail: 'بعد از زنجیره ۵ جواب کامل آزاد می‌شود و فقط زمان سؤال فعال را بیشتر می‌کند.' },
  { title: 'فرصت دوباره', detail: 'بعد از جواب کامل به سؤال سخت آزاد می‌شود؛ تلاش دوم حداکثر ۵۰٪ امتیاز دارد.' },
] as const;
